import { render, staticRenderFns } from "./ProjectDetailsGallery.vue?vue&type=template&id=5458803d&scoped=true&"
import script from "./ProjectDetailsGallery.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsGallery.vue?vue&type=style&index=0&id=5458803d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5458803d",
  null
  
)

export default component.exports